export default __webpack_public_path__ + "static/media/proluxsolutions_logo.29c482e8.jfif";